import React from 'react';
import styles from './CardContent.module.css';
import { Language } from '../Language';

export const CardContent = ({ title, description }) => (
  <div className={styles.wrapper}>
    <div>
      <Language {...title} tagName="strong" />
    </div>
    <Language {...description} tagName="div" />
  </div>
);
